import { Builder } from '@builder.io/react';

import SolutionsWhy from './index';

Builder.registerComponent(SolutionsWhy, {
  name: 'SolutionsWhy',
  inputs: [
    {
      name: 'id',
      type: 'string'
    },
    {
      name: 'overtitle',
      type: 'string'
    },
    {
      name: 'title',
      type: 'string'
    },
    {
      name: 'subtitle',
      type: 'longText'
    },
    {
      name: 'texts',
      type: 'list',
      defaultValue: [{ text: 'default text' }],
      subFields: [
        {
          name: 'text',
          type: 'longText'
        }
      ]
    },
    {
      name: 'cta',
      type: 'boolean',
      defaultValue: false
    }
  ]
});
